import { INTENT_TYPE } from '../../constants';
import { type ConvergenceRule } from '../types';

/**
 * `S-RECENT-EXACT`, `S-RECENT-PREFIX`, `S-RECENT-REORDERED` — the design's `S-RECENT-NAV`
 * (priority 980), split by how the query relates to a recently viewed title.
 *
 * A user retyping something they just had open is navigating, not asking, however the
 * words are shaped: `how to rotate the signing keys` is a question until it is also the
 * title of the page they read this morning. These rules sit with the other Search
 * protections so no Chat grammar can override them, and each reports its own pattern so
 * the looser relations can be measured and rolled back independently.
 *
 * Three departures from the design, recorded in the README: the prefix relation needs no
 * navigation cue; the reordered relation has no counterpart; and there is no `UNAVAILABLE`
 * state, so with no titles supplied all three decline and the catalog below runs as before.
 * The relations themselves are defined in `features/recent-match.ts`.
 */
export const recentExactRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	pattern: 'RECENT_EXACT',
	matches: (features) => features.recentMatch === 'EXACT',
};

export const recentPrefixRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	pattern: 'RECENT_PREFIX',
	matches: (features) => features.recentMatch === 'PREFIX',
};

export const recentReorderedRule: ConvergenceRule = {
	type: INTENT_TYPE.FPS,
	pattern: 'RECENT_REORDERED',
	matches: (features) => features.recentMatch === 'REORDERED',
};
